module.exports = __webpack_public_path__ + "static/media/coin.0c5a5b1b.glb";